<div class="container-fluid">
    <!-- Header Section -->
    <header class="dashboard-header">
        <div class="left-section">
            <h1 class="dashboard-title">Transactions</h1>
        </div>

        <div class="right-section">
            <img src="assets/icons/img-notification.svg" class="bell-icon" alt="Notifications"
                (click)="toggleNotifications()" />
        </div>
    </header>

    <!-- Transactions Section -->
    <div class="transactions-container mb-5">
        <div class="transactions-body">
            <div class="transactions-header">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <div class="back-link" (click)="goBack()">
                        <img src="assets/icons/arrow-right-40.svg" alt="Back" />
                        <span>All Transactions</span>
                    </div>
                </div>

                <!-- Transaction Filters - Hide on very small mobile -->
                <app-table-filters *ngIf="!isMobile || isTablet" [filters]="transactionFilters"
                    [initialFilters]="activeTransactionFilters"
                    (filterChange)="onTransactionFilterChange($event)"></app-table-filters>

                <!-- Mobile Filters Button -->
                <div *ngIf="isMobile && !isTablet" class="mobile-filters-section">
                    <button class="btn-filters" (click)="toggleMobileFilters()">
                        <img src="assets/icons/filter.svg" alt="Filters" />
                        <span>Filters</span>
                    </button>

                    <!-- Mobile Filters Dropdown - Reusing Table Filters Component -->
                    <div class="mobile-filters-dropdown" *ngIf="showMobileFilters">
                        <app-table-filters [filters]="transactionFilters" [initialFilters]="activeTransactionFilters"
                            (filterChange)="onTransactionFilterChange($event)"></app-table-filters>
                    </div>
                </div>
            </div>

            <!-- Desktop/Tablet View: Data Table *ngIf="isMobile || isTablet"-->
            <div>
                <app-data-table #transactionTable [columns]="transactionColumns" [data]="transactionData"
                    [config]="transactionConfig" [isMobile]="isMobile" [loading]="loading"></app-data-table>
            </div>


            <!-- Mobile View: Mobile Transactions List Component -->
            <!-- <app-mobile-transactions-list *ngIf="isMobile && !isTablet" [transactions]="transactionData"
                [columns]="transactionColumns" [sortConfig]="sortConfig" (transactionClick)="openModal($event)"
                (moreOptionsClick)="showOptionsPopup($event.transaction.id.toString(), $event.event)"
                (sortChange)="onMobileSortChange($event)">
            </app-mobile-transactions-list> -->
        </div>

        <!-- View All Link -->
        <div class="d-flex justify-content-center mt-2">
            <app-view-all-button label="View all transactions" backgroundColor="var(--bg-primary2)"
                textColor="var(--color-primary1)">
            </app-view-all-button>
        </div>
    </div>
</div>

<!-- Options Popup (appears when clicking more-vertical icon) -->
<div class="options-popup" *ngIf="selectedTransactionId" [style.top.px]="popupPosition.top"
    [style.left.px]="popupPosition.left">
    <div class="popup-option" (click)="openTransactionDetailsModal()">
        <img src="assets/icons/information.svg" alt="details" class="option-icon" />
        <span>Transaction Details</span>
    </div>
    <div class="popup-option" (click)="downloadStatement()">
        <img src="assets/icons/file-download.svg" alt="download" class="option-icon" />
        <span>Download Statement</span>
    </div>
</div>

<!-- Backdrop to close popup when clicking outside -->
<div class="popup-backdrop" *ngIf="selectedTransactionId" (click)="closeOptionsPopup()"></div>

<!-- Transaction Details Modal -->
<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h5 class="modal-title">Transaction Details</h5>
            <button class="btn-done" (click)="closeModal()">Done</button>
        </div>
        <app-transaction-details-modal *ngIf="selectedTransaction" [transaction]="selectedTransaction">
        </app-transaction-details-modal>
    </div>
</div>

<!-- Download Statement Modal -->
<div class="modal-overlay" *ngIf="isDownloadModalOpen" (click)="closeDownloadModal()">
    <div class="download-modal-container" (click)="$event.stopPropagation(); !downloadLoading && confirmDownload()"
        [class.disabled]="downloadLoading">
        <h3 *ngIf="!downloadLoading" class="download-modal-title">Download Statement</h3>
        <span *ngIf="downloadLoading" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
        <span *ngIf="downloadLoading">Downloading...</span>
    </div>
</div>